import type { SessionResponseData } from "@veritab/api-contracts";
import axios, { AxiosError } from "axios";

import { ApiError } from "@/shared/lib/errors";

export const authApi = axios.create({
  baseURL: `${import.meta.env.VITE_CORE_API_URL}/auth`,
});

export const getSession = async () => {
  try {
    const response = await authApi.get("/session", {
      withCredentials: true,
    });
    const responseData = response.data as SessionResponseData;
    if (!responseData.success) {
      throw new Error(responseData.message);
    }
    return responseData.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      // Handle 401 specifically - user is not authenticated
      if (error.response?.status === 401) {
        return { user: null, organization: null };
      }
      console.error(error);
      throw new ApiError(error);
    }
    console.error(error);
    throw new Error("An unknown error occurred");
  }
};
